import {FC} from "react";
import {LearnCategory} from "../../../lib/src/api/repositories/learn-repository";
import {useApiCall} from "../../../lib/src/api";
import {config} from "../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const DeleteLearnCategoryModal: FC<{ category: LearnCategory, reload: () => void }> = (props) => {
  const { learn } = useApiCall(config)
  const archive = async () => {
    await learn.deleteCategory(props.category.id)
    props.reload()
  }

  return <>
    <div>Je staat op het punt om de volgende categorie te verwijderen. Doorgaan?</div>
    <div className={'font-bold'}>&middot; {props.category.name}</div>
    <ModalFooter text={'Verwijder'} onSubmit={archive} />
  </>
}